import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import styles from './styles'

const SECTION = 'suggested_steps'

const SuggestedSteps = ({ classes, steps, collapsed, onToggle, onAction }) => (
  <section className={classes.root}>
    <div className={classes.header}>
      <h2 className={classes.label}>Suggested steps</h2>
      <button
        type="button"
        className={classes.toggle}
        onClick={onToggle}
        aria-expanded={!collapsed}
      >
        {collapsed ? 'Expand' : 'Collapse'}
        <Icon
          icon="tabler:chevron-down"
          className={classes.toggleIcon}
          style={{ transform: collapsed ? 'none' : 'rotate(180deg)' }}
        />
      </button>
    </div>

    {!collapsed && (
      <div className={classes.grid}>
        {steps.map(step => (
          <button
            key={step.id}
            type="button"
            className={classes.item}
            onClick={() =>
              onAction(step.action, { section: SECTION, itemId: step.id })
            }
          >
            <span className={classes.itemIcon}>
              <Icon icon={step.icon} className={classes.itemIconGlyph} />
            </span>
            <span className={classes.itemTitle}>{step.title}</span>
            <Icon icon="tabler:arrow-right" className={classes.itemArrow} />
          </button>
        ))}
      </div>
    )}
  </section>
)

export default withStyles(styles)(SuggestedSteps)
